/* eslint no-restricted-globals:0 */
import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { 
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableRow
} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    fontSize: '18px',
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      padding: '20px',
      textAlign: 'left',
      margin: '0 auto',
      [theme.breakpoints.down('lg')]: {
        width: '90%',
      },
      [theme.breakpoints.up('lg')]: {
        width: '70%',
      },
      '& > h1': {
        marginTop: '0px',
        marginBottom: '0px',
        color: '#0e419b',
        textAlign: 'center'
      }
    },
  },
  container: {
    padding: '10px'
  },
  grid: {
    textAlign: 'center',
    '& > h2': {
      textAlign: 'left',
      color: '#0e419b'
    },
    '& > p': {
      textAlign: 'left',
      verticalAlign: 'middle'
    }
  },
  gridimg: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  underline: {
    borderBottom: '2px solid #c5cae9',
  },
  image: {

    [theme.breakpoints.down('xs')]: {
      minWidth: '150px',
      maxWidth: '200px',
    },
    [theme.breakpoints.up('xs')]: {
      width: '300px',
    },
  },
  table: {
      width: '100%',
  },
  tr: {
    '& > *': {
      [theme.breakpoints.down('md')]: {
        padding: '0px',
        fontSize: '14px',
      },
      [theme.breakpoints.up('md')]: {
        padding: '5px',
        fontSize: '16px',
      },
      '& > p': {
        fontSize:'12px',
        textAlign: 'left',
        margin: '0px'
      }
    }
  },
}));

const Features = props => {

  const classes = useStyles();

  return (
    <div className={classes.root}>

    <Paper elevation={3}>
      <h1>CONNECTCOMPASSの特徴</h1>
      <Grid container className={classes.container}>
        <Grid item xs={12} md={5} className={classes.gridimg}>
          <img src={`${process.env.PUBLIC_URL}/img/img1.png`} className={classes.image} alt={"グラフ"} />
        </Grid>
        <Grid item xs={12} md={7} className={classes.grid}>
          <h2>①導入方法</h2>
          <p>
            導入会社により、対象のパソコンにconnectcompassをインストールします。
            これ以外に特別な操作は必要ありません。
            様々なレセプトコンピュータに対応しており、普段お使いのレセプトコンピュータにツールを導入します。
            導入後、分析に利用するためのIDとPASSWORDを発行いたします。
          </p>
        </Grid>
      </Grid>

      <div className={classes.underline}> </div>

      <Grid container className={classes.container}>
        <Grid item xs={12} md={5} className={classes.gridimg}>
          <img src={`${process.env.PUBLIC_URL}/img/img2.png`}  className={classes.image} alt={"グラフ"} />
        </Grid>
        <Grid item xs={12} md={7} className={classes.grid}>
          <h2>②分析</h2>
          <p>
            WEBで毎日の処方箋枚数、受付回数の集計データや様々なグラフをチェックする事が出来ます。
            １つの薬局のみでのご利用だけでなく、複数の薬局や、法人単位での纏まった表示が可能です。
            リアルタイムで処方箋の枚数などさまざまな状況確認および分析結果を確認する事ができます。
            分析結果の中でも、常に表示したいグラフだけ表示する設定ができます。
          </p>
        </Grid>
      </Grid>

      <div className={classes.underline}> </div>

      <Grid container className={classes.container}>
        <Grid item xs={12} md={5} className={classes.gridimg}>
          <img src={`${process.env.PUBLIC_URL}/img/img3.png`} className={classes.image} alt={"グラフ"}  />
        </Grid>
        <Grid item xs={12} md={7} className={classes.grid}>
          <h2>③配信機能</h2>
          <p>
            分析結果などの速報を、メールやSNSでお知らせします。
            離れた場所からでも状況の確認ができ、情報へアクセスするためのきっかけを得ることができます。
          </p>
        </Grid>
      </Grid>

      
      <div className={classes.underline}> </div>

      <Grid container className={classes.container}>
        <Grid item xs={12} md={5} className={classes.gridimg}>
          <img src={`${process.env.PUBLIC_URL}/img/img4.png`}  className={classes.image}alt={"グラフ"} />
        </Grid>
        <Grid item xs={12} md={7} className={classes.grid}>
          <h2>④動作環境</h2>





          <Table className={classes.table} >
            <TableBody>
              <TableRow className={classes.tr}>
                <TableCell component="th" scope="row" align="left" style={{minWidth: "100px"}}>
                  ツール導入ＰＣ
                </TableCell>
                <TableCell align="left">Windows10 64bit推奨
                  <p>・ネットワークのセキュリティ設定によってはツール導入が難しい場合がございます。</p>
                  <p>・Windows7、32bitでもメモリ、CPUの空き容量によっては導入可能な場合がございます。</p>
                </TableCell>
              </TableRow>
              <TableRow className={classes.tr}>
                <TableCell component="th" scope="row" align="left" rowSpan="2">
                  Web　推奨ブラウザ
                </TableCell>
                <TableCell align="left">Google Chrome 最新版</TableCell>
              </TableRow>
              <TableRow className={classes.tr}>
                <TableCell align="left">Microsoft Edge 最新版</TableCell>
              </TableRow>
              <TableRow className={classes.tr}>
                <TableCell component="th" scope="row" align="left">
                  android　推奨ブラウザ
                </TableCell>
                <TableCell align="left">Google Chrome 最新版</TableCell>
              </TableRow>
              <TableRow className={classes.tr}>
                <TableCell component="th" scope="row" align="left">
                  IOS　推奨ブラウザ
                </TableCell>
                <TableCell align="left">Safari 最新版</TableCell>
              </TableRow>
            </TableBody>
          </Table>



          
        </Grid>
      </Grid>
    </Paper>
  </div>
  );
}

Features.propTypes = {
    className: PropTypes.string,
  }

export default Features;